import ApiServer from "./ApiServer.js";
import FizConfig from "./FizConfig.js";
import deviceId from "./lib/deviceId.js";
import * as websocket from "./util/websocket.js";
import * as i18n from "./i18n.ts";

var 
  messaging,
  defaultRegister=function(onSuccess){if(onSuccess) onSuccess()},
  result={};

function initWebSocketNotification(onSuccess){
    Notification.requestPermission(function (permission) {
      console.log('permission '+permission)
      if (permission === "granted") {
        websocket.subscribe("AllPush",function(websocketPushMessageBean){
          console.log("pushed via websocket",websocketPushMessageBean)
          var 
            data = websocketPushMessageBean.push,
            notification = new Notification(i18n.get("AppName"), {
              badge : FizConfig.CONFIG_PARTNER_TYPE+'/badge.svg',
              icon : data.authorIcon?(data.authorIcon.indexOf('data:')===0?data.authorIcon:data.authorIcon+'w=120&h=120&s=c'):FizConfig.CONFIG_PARTNER_TYPE+'/notification.png',
              data: data,
              image:data.image?data.image+"w=1024&h=1024&s=r":undefined,
              body : data.message
            });
          notification.onclick = function(event) {
            event.preventDefault(); 
            var 
              url = "/home.php?push="+encodeURIComponent(data.messageType)+ (data.familyId?("&familyId="+encodeURIComponent(data.familyId)):"")+(data.targetId?("&targetId="+encodeURIComponent(data.targetId)):"");
            window.location = url;
          }
          //setTimeout(notification.close.bind(notification), 10000); 
        });
      }
    }).then(onSuccess);
}

function initFirebaseNotification(onSuccess){
  try{
    function load(script_url) {
      return new Promise(function(resolve, reject) {
        var script = document.createElement('script');
        script.onload = resolve;
        script.src = script_url
        document.head.appendChild(script);
      });
    }
    
    load("https://www.gstatic.com/firebasejs/3.6.8/firebase.js")
      .then(()=>load("https://www.gstatic.com/firebasejs/3.6.8/firebase-app.js"))
      .then(()=>load("https://www.gstatic.com/firebasejs/3.6.8/firebase-messaging.js"))
      .then(()=>{
       window.firebase.initializeApp(FizConfig.firebase);
    messaging = window.firebase.messaging();
    
    //code from https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/getRegistration
    navigator.serviceWorker.getRegistration({ scope: '/' }).then(function(ServiceWorkerRegistration) { 
      messaging.useServiceWorker(ServiceWorkerRegistration);

      
      var lastToken;
      function getToken(){
        messaging.getToken()
        .then(function(currentToken) {
          if (currentToken) {
            if(lastToken!==currentToken){
              sendTokenToServer(currentToken);
              lastToken=currentToken
            }
          } else {
            throw new Error("getToken() give no token");
          }
        }).catch(function(err) {
          console.log('An error occurred while retrieving token. ', err);
          ApiServer.devicedelete(deviceId);
          initWebSocketNotification()
        });
      }

      
      messaging.requestPermission().then(function() {
        console.log('Notification permission granted.');
        getToken()
      })
      .catch(function(err) {
        console.log('Unable to get permission to notify.', err);
      });
    });
    
    function sendTokenToServer(currentToken){
      ApiServer.devicesetconfig(new ApiServer.types.DeviceConfigBean({
        "deviceId":deviceId,
        "notificationTokenId":currentToken,
        "modelType":'WebFirebase',
        "languageSystem":navigator.languages.join(', ').substring(0,45),
        "partnerType":FizConfig.CONFIG_PARTNER_TYPE,
        "applicationVersion":FizConfig.jsVersion,
        "systemName":navigator.platform.substring(0,500),
        "systemVersion":navigator.userAgent.substring(0,500)
      }),onSuccess,function(){
        //do not want default error handler
      });
      
    }

    
  //Callback fired if Instance ID token is updated.
    messaging.onTokenRefresh(function() {
      messaging.getToken()
      .then(function(refreshedToken) {
        console.log('Token refreshed.');
        // Send Instance ID token to app server.
        sendTokenToServer(refreshedToken);
        // ...
      })
      .catch(function(err) {
        console.log('Unable to retrieve refreshed token ', err);
      });
    });
    
    messaging.onMessage(function(payload) {
      console.log("Message received. ", payload);
      // ...
    });
    })
  }catch(e){
    console.log(e)
  }
}

//if we cannot have a fix deviceId we cannot use all this
if(!deviceId){
  result.register = defaultRegister;
}else if(navigator.serviceWorker && FizConfig.serviceWorker && FizConfig.firebase){
  result.register = function(onSuccess){
    //first of all do not register twice
    result.register = defaultRegister;
    //then wait 10s before launching notifications stuff
    setTimeout(function(){initFirebaseNotification(onSuccess)},10000);
  }
  
}else if (FizConfig.websocketNotification && "Notification" in window) {
  result.register = function(onSuccess){
    //first of all do not register twice
    result.register = defaultRegister;
    initWebSocketNotification(onSuccess);
  }  
}
  
export default result;